import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CampaignUmbrellaAddEditRBAC = {
  pageID: 'dac0fe564769570080d24debe9659c17',
  elementID: {
    ViewPage: '21be8fb5631c9d333cdd3f707d31f201',
    SaveEdit: 'c0aec469d01c9d3348130ac9dad1659c',
    SaveCreate: '04a7a20be6be799adcb092b33054b01c',
  },
} as const

export const useRBACCampaignUmbrellaAddEditRBACRBAC = createUseRBAC(
  CampaignUmbrellaAddEditRBAC.elementID,
)

export type UseRBACCampaignUmbrellaAddEditRBACRBACType = ReturnType<
  typeof useRBACCampaignUmbrellaAddEditRBACRBAC
>
